<template>
    <div class="thy-provider">
        <div class="input-group">
            <label for="thy-api-url">THY API URL</label>
            <input id="thy-api-url" type="text" v-model="thyApiUrl" placeholder="THY API URL'nizi girin" />
        </div>
        <div class="input-group">
            <label for="thy-client-id">THY Client ID:</label>
            <input id="thy-client-id" type="text" v-model="thyClientId" placeholder="THY Client ID'nizi girin" />
        </div>
        <div class="input-group">
            <label for="thy-client-secret">THY Client Secret:</label>
            <input id="thy-client-secret" type="text" v-model="thyClientSecret"
                placeholder="THY Client Secret'inizi girin" />
        </div>
        <div class="input-group">
            <label for="thy-name">THY ParticipatingOrg => Name:</label>
            <input id="thy-name" type="text" v-model="thyName"
                placeholder="THY Distribution Chain => ParticipatingOrg => Name" />
        </div>
        <div class="input-group">
            <label for="thy-orgId">THY ParticipatingOrg => OrgId:</label>
            <input id="thy-orgId" type="text" v-model="thyOrgId"
                placeholder="THY Distribution Chain => ParticipatingOrg => OrgId" />
        </div>
        <div class="input-group">
            <label for="thy-salesBranchId">THY SalesBranchId:</label>
            <input id="thy-salesBranchId" type="text" v-model="thySalesBranchId"
                placeholder="THY Distribution Chain => SalesBranch => SalesBranchId" />
        </div>
        <v-btn color="primary" class="mt-4" @click="saveProviderConfig">
            Kaydet
        </v-btn>
    </div>
</template>

<script>
export default {
    name: "THYNDCProvider",
    props: {
        providerData: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            thyClientId: "",
            thyClientSecret: "",
            thyName: "",
            thyOrgId: "",
            thySalesBranchId: "",
            thyApiUrl: "",
        }
    },
    watch: {
        // Üst bileşenden (Parent) gelen veriyi izler ve formu günceller
        providerData: {
            handler(newValue) {
                this.fillForm(newValue);
            },
            deep: true,
            immediate: true // İlk yüklemede boş veya dolu gelme durumunu yakalar
        }
    },
    methods: {
        fillForm(data) {
            // veri var ve içi doluysa form alanlarını doldurur
            if (data && Object.keys(data).length > 0) {
                this.thyApiUrl = data.Address || data.url || "";
                this.thyClientId = data.ServiceUsername || "";
                this.thyClientSecret = data.ServicePassword || "";
                // Birleşik gelen ServiceSecurityKey alanını (Name-OrgId-SalesBranchId) parçalıyoruz
                const securityKey = data.ServiceSecurityKey || "";
                if (securityKey) {
                    const keys = securityKey.split("-");
                    this.thyName = keys[0] || "";
                    this.thyOrgId = keys[1] || "";
                    this.thySalesBranchId = keys[2] || "";
                } else {
                    this.thyName = "";
                    this.thyOrgId = "";
                    this.thySalesBranchId = "";
                }
            } else {
                // veri boş veya null geldiyse form alanlarını temizler
                this.thyApiUrl = "";
                this.thyClientId = "";
                this.thyClientSecret = "";
                this.thyName = "";
                this.thyOrgId = "";
                this.thySalesBranchId = "";
            }
        },
        saveProviderConfig() {
            if (!this.thyClientId || !this.thyClientSecret || !this.thyName || !this.thyOrgId || !this.thySalesBranchId || !this.thyApiUrl)
                return this.$toast.error("Lütfen tüm alanları doldurun.");

            // Gelen datada ID kontrolüne göre add/edit modu belirlenir
            const type = this.providerData && this.providerData.Id ? 'edit' : 'add';

            const config = {
                ServiceUsername: this.thyClientId,
                ServicePassword: this.thyClientSecret,
                ServiceSecurityKey: `${this.thyName}-${this.thyOrgId}-${this.thySalesBranchId}`,
                Address: this.thyApiUrl,
            }
            this.$emit("save", config, type);
        }
    }
}
</script>

<style scoped>
.thy-provider {
    font-family: 'Roboto', sans-serif;
}

.input-group {
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
}

.input-group label {
    margin-bottom: 8px;
    font-weight: 500;
    color: #333;
    font-size: 14px;
}

.input-group input {
    padding: 10px 12px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 14px;
    transition: all 0.3s ease;
}

.input-group input:focus {
    outline: none;
    border-color: #1976d2;
    box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.1);
}

.input-group input::placeholder {
    color: #999;
}

.mt-4 {
    margin-top: 16px;
    padding: 10px 24px;
    font-size: 14px;
    font-weight: 500;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.2s ease;
}
</style>